import { defineStore } from 'pinia'
import { createResource } from '@frappe-ui/resources/resources.js'
import router from '@/router'
import { ref, computed } from 'vue'

export const sessionStore = defineStore('retiora-session', () => {
  function sessionUser() {
    let cookies = new URLSearchParams(document.cookie.split('; ').join('&'))
    let _sessionUser = cookies.get('user_id')
    if (_sessionUser === 'Guest') {
      _sessionUser = null
    }
    return _sessionUser
  }

  function syncUserCookie(userId, rememberMe = false) {
    if (userId && userId !== 'Guest') {
      const maxAge = rememberMe ? '; max-age=2592000' : ''
      document.cookie = `user_id=${encodeURIComponent(userId)}; path=/${maxAge}`
    }
  }

  let user = ref(sessionUser())
  const isLoggedIn = computed(() => !!user.value)

  const login = createResource({
    url: 'retiora.api.auth.login',
    onSuccess(data) {
      // Frappe sets the sid and user_id cookies as part of the login response.
      const loggedInUser = data?.user_id || sessionUser()
      syncUserCookie(loggedInUser, login.params?.remember_me)
      user.value = loggedInUser
      login.reset()
      router.replace({ name: 'dashboard' })
    },
  })

  const logout = createResource({
    url: 'logout',
    onSuccess() {
      user.value = null
      logout.reset()
      router.replace({ name: 'login' })
    },
  })

  return {
    user,
    isLoggedIn,
    login,
    logout,
  }
})
